/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProdevisWebhookRequest } from '../models/ProdevisWebhookRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ProdevisEmailService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Webhook : devis Prodevis recu par e-mail
     * Appele par le relais SMTP quand un e-mail Prodevis arrive : authentifie par le header `X-Webhook-Secret` (403 sinon). Identifie l'entreprise par l'adresse destinataire (404), extrait le numero de devis de l'objet (400 s'il est absent), puis importe le devis et ses pieces jointes dans Lola et le Drive. Chaque appel est trace dans le journal des imports Prodevis.
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public prodevisEmailHandle(
        requestBody: ProdevisWebhookRequest,
    ): CancelablePromise<{
        success: boolean;
        message: string;
        quote_number: string | null;
        company: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhooks/prodevis-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Authorization error`,
                422: `Erreur de validation`,
            },
        });
    }
}
